import Button from "@/lib/Button";
import EditEmails from "@/lib/sendEmail/EditEmails";
import AttachFiles from "@/lib/AttachFiles";
import useToPage from "@/lib/useToPage";
import { useFetchRfq } from "@/lib/queries/hooks";
import Message from "@/lib/sendEmail/Message";
import $api from "@/lib/queries/openapi";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import useGetCurrentQuoteRevision from "@/lib/SelectedQuoteRevisionIdContext/useGetCurrentQuoteRevision";
import Print from "@/lib/Print";
import Download from "@/lib/Download";
import useGetTeamSettings from "@/lib/queries/useGetTeamSettings";
import useUploadFiles from "@/lib/queries/useUploadFiles";

export default function Send() {
  const { toDone } = useToPage();
  const rfq = useFetchRfq();
  const quoteRevision = useGetCurrentQuoteRevision();
  const canEditQuoteRevision = quoteRevision?.can_edit;
  const { teamSlug } = useParams();
  const queryClient = useQueryClient();
  const teamSettings = useGetTeamSettings(teamSlug);

  const { uploadFiles, isUploading, fileIds, files, setFiles } = useUploadFiles(
    {},
  );

  const { mutate: send, isPending } = $api.useMutation(
    "post",
    "/api/teams/{team_slug}/quote_revisions/{id}/send",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs/{id}/full"],
        });
        toDone();
      },
    },
  );

  if (!rfq || !quoteRevision) return null;

  const quotePdfUrl = `/api/teams/${teamSlug}/quote_revisions/${quoteRevision.id}/quote.pdf`;

  return (
    <div className="w-full h-full flex">
      <div className="h-full basis-2/3 flex flex-col p-2 gap-1">
        <div className="flex gap-2 self-end">
          <Print fileUrl={quotePdfUrl} />
          <Download fileUrl={quotePdfUrl} />
        </div>
        {rfq && (
          <iframe
            src={`${quotePdfUrl}#toolbar=0&navpanes=0&view=FitH&zoom=page-fit`}
            className="h-full w-full"
          />
        )}
      </div>
      <div className="bg-white h-full basis-1/3 flex flex-col justify-between">
        <div className="flex flex-col gap-6 p-6">
          <EditEmails
            quoteRevisionId={quoteRevision.id}
            disabled={!canEditQuoteRevision}
          />
          <Message
            quoteRevisionId={quoteRevision.id}
            disabled={!canEditQuoteRevision}
            defaultEmailBody={teamSettings?.default_email_body ?? ""}
          />
          <AttachFiles
            files={files}
            setFiles={(files) => {
              setFiles(files);
              uploadFiles(files);
            }}
            disabled={!canEditQuoteRevision}
          />
        </div>
        {canEditQuoteRevision && (
          <div className="flex justify-end p-4">
            <Button
              primary
              loading={isPending || isUploading}
              onClick={() => {
                send({
                  params: {
                    path: { team_slug: teamSlug!, id: quoteRevision.id },
                  },
                  body: {
                    file_ids: fileIds,
                  },
                });
              }}
            >
              Send Quote
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
